export default __webpack_public_path__ + "static/media/3014.854699c4.jpg";